module.exports = __webpack_public_path__ + "static/media/WHO_WE_HELP_2.3f173c7c.png";